
// Alpine
// import Alpine from 'alpinejs';
// import quicksearch from './alpinejs/quicksearch'
// import collapse from '@alpinejs/collapse';
// import persist from '@alpinejs/persist';
// import intersect from '@alpinejs/intersect';
import cookiejs from 'cookiejs';

// Alpine.plugin(quicksearch)
// Alpine.plugin(collapse)
// Alpine.plugin(persist)
// Alpine.plugin(intersect)
// Alpine.magic('cookiejs', () => cookiejs);
//
//
// window.Alpine = Alpine;
// Alpine.start();

document.addEventListener('alpine:init', function(){
  Alpine.magic('cookiejs', () => cookiejs);
})

// Stimulus
import { Application } from "stimulus"
import ModalController from './controllers/modal_controller'
import ParkedBadgeController from './controllers/parked/badge_controller'
import ParkedParkedController from './controllers/parked/parked_controller'
import AjaxForm from './controllers/ajax_form_controller'
import StatisticsMachineWhatsappClickController from './controllers/statistics/machine/whatsapp_click_controller'
import StatisticsMachineShoplinkClickController from './controllers/statistics/machine/shoplink_click_controller'
import StatisticsMachineHomepageClickController from './controllers/statistics/machine/homepage_click_controller'
import LightboxController from './controllers/lightbox_controller'
import AdminToolbarController from './controllers/admin/toolbar_controller'
import PanoramaController from './controllers/panorama_controller'

const application = Application.start();
application.register('modal', ModalController);
application.register('parked--badge', ParkedBadgeController);
application.register('parked--parked', ParkedParkedController);
application.register('ajax-form', AjaxForm);
application.register('statistics--machine--whatsapp-click', StatisticsMachineWhatsappClickController)
application.register('statistics--machine--shoplink-click', StatisticsMachineShoplinkClickController)
application.register('statistics--machine--homepage-click', StatisticsMachineHomepageClickController)
application.register('lightbox', LightboxController)
application.register('admin--toolbar', AdminToolbarController)
application.register('panorama', PanoramaController);

